<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Lesson Planning / Execution</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <v-autocomplete dense rounded v-model="role" item-value="id" :items="roles" @change="getCourses()"
              item-text="name" label="Role" outlined></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" v-if="ay_list!=''">
            <v-autocomplete dense rounded v-model="ay" item-value="id" :items="ay_list" item-text="ay"
              label="Academic Year" outlined></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" v-if="course_list!=''">
            <v-autocomplete dense rounded v-model="course" item-value="id" :items="course_list" item-text="course"
              label="Subject" outlined></v-autocomplete>
          </v-col>
        </v-row>
        <span v-if="role && course">
          <v-row dense justify="center" v-if="role==2">
            <v-btn dense :loading="loader" class="mr-5" outlined @click="fetchData()" rounded
              color="success">Plans</v-btn>
            <v-btn dense :loading="loader" class="ml-5" outlined @click="lession_plan_execution()" rounded
              color="warning">Plan Execution</v-btn>
          </v-row>
          <v-row v-else dense justify="center">
            <v-btn dense :loading="loader" rounded color="primary" @click="fetchData()">Fetch</v-btn>
          </v-row>
        </span>
      </v-card>
      <v-dialog v-model="dialog" fullscreen>
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> Lesson Plans </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab small color="white" outlined icon @click="dialog = false"><v-icon> mdi-close </v-icon></v-btn>
          </v-toolbar>
          <show-lesson-plan :chapters_list="chapters_list" :plan_list="plan_list" :role="role"
            :course_plan_week_list="course_plan_week_list" :ay="ay" :course="course" :lesson_no="lesson_no"
            :islessonplanapproved="islessonplanapproved"></show-lesson-plan>
        </v-card>

      </v-dialog>
      <v-dialog v-model="dialog_execution" fullscreen>
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> Lesson Plan Execution </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab small color="white" outlined icon @click="dialog_execution = false"><v-icon> mdi-close
              </v-icon></v-btn>
          </v-toolbar>
          <lesson-plan-execution-planner :course="course"></lesson-plan-execution-planner>
        </v-card>

      </v-dialog>
    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import ShowLessonPlanList from './ShowLessonPlanList'
import LessionPlanExecutionPlanner from './LessionPlanExecutionPlanner'
export default {
   components:{
      'show-lesson-plan':ShowLessonPlanList,
    'lesson-plan-execution-planner': LessionPlanExecutionPlanner,
    Breadcrumbs
      },
    data: () => ({
      islessonplanapproved:false,
      dialog:false,
      dialog_execution: false,
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      search:"",
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      title:"",
      description:"",
      lesson_no:null,
      table_fields: {
            "Sr. No": "sr_no",
            "Lecture No": "lecture_no",
            Chapter: "unit",
            "Concept & Skills / Topic": "topic",
            "Learning Outcomes": "learning_outcomes",
            "Instructional Tools & Reference": "instructional_tool_refernences",
            Pedagogy: "pedagogy",
            "Activity / Assignment / Research": "activity_assignment_research",
            Assessment: "assessment",
            Examination: "exam_name",
      },
       headers: [
          { text: "Sr. No.", value: "sr_no" },
          { text: "Lecture No", value: "lecture_no" },
          { text: "Chapter", value: "unit" },
          { text: "Concept & Skills / Topic", value: "topic" },
          { text: "Learning Outcomes", value: "learning_outcomes" },
          {
              text: "Instructional Tools & Reference",
              value: "instructional_tool_refernences",
          },
          { text: "Pedagogy", value: "pedagogy" },
          {
              text: " Activity / Assignment / Research",
              value: "activity_assignment_research",
          },
          { text: "Assessment", value: "assessment" },
          { text: "Examination", value: "exam_name" },
          { text: "Actions", value: "action", sortable: false },
        ],
      roles:[],role:"",course_list:[],course:"",plan_list:[],ay_list:[],ay:"",course_plan_week_list:[],chapters_list:[],
  }),
   methods: {
    lession_plan_execution(){
      this.dialog_execution = true
    },
     async fetchData() {
      //this.course_list=[]
        const data = {
              id: this.role,
              course:this.course,
              ay:this.ay
            };
        try {
          const res = await axios.post("/LessonPlanning/getCoursesPlans",data);
          if (res.data.flag == "YES") {
                this.plan_list=res.data.course_plans
                this.lesson_no = res.data.lesson_plan;
                //this.islessonplanapproved=res.data.islessonplanapproved
                this.course_plan_week_list=res.data.course_plan_week_list
                this.chapters_list=res.data.chapters_list
                this.dialog=true

          }
           else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
          else{
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
     async getCourses() {
      this.course_list=[]
        const data = {
                    id: this.role,
                };
        try {
          const res = await axios.post("/LessonPlanning/getCoursesForRole",data);
          if (res.data.flag == "YES") {
            this.course_list=res.data.courses,
            this.ay_list=res.data.ay_list,
            this.ay=res.data.cay
          }
           else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
          else{
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
       async onLoad() {
        try {
          const res = await axios.post("/LessonPlanning/getPlannerAndSubjecthead");
          if (res.data.flag == "YES") {
            this.roles=res.data.roles
           // this.role=this.roles[0].id
          }
           else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
          else{
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>